import ProductsListBgColorNoneP0 from "../Promotion/ProductsListBgColorNoneP0"

export default function ProductsRecommendation() {
    return (
        <div className="products-recommendation">
            <div className="styles_containerPage__eKW1A MuiBox-root css-0 !mt-[20px]">
                <div className="styles_wrapper_media__8E69V mobile-padding-0">
                    <div className="styles_wrapper_media_container__mzr38">
                        <div className="styles_SliderProductWrap__FM9kz" style={{ backgroundSize: "100% 100%" }}>
                            <div
                                className="styles_wrapperTitle__DaSRf"
                                style={{ visibility: "visible" }}
                            >
                                <h2 className="styles_title__W7HFl styles_wrapperContentTitle__AGJR6">
                                    <span className="styles_contentTitle__y8kvU">Có thể bạn sẽ thích</span>
                                </h2>
                            </div>

                            <div className="false css-j7qwjs">
                                <ProductsListBgColorNoneP0 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
